/* Mobil/tablet: text pod produktem přisunutý těsně k fotce.
   První fotka má dole černý okraj různé výšky – spočítá se z obrázku a o tolik se text posune nahoru. */
(function () {
  var mq = window.matchMedia('(max-width: 948px)');
  var cache = {};

  function bottomFraction(img) {
    var w = 120;
    var h = Math.max(1, Math.round(w * img.naturalHeight / img.naturalWidth));
    var c = document.createElement('canvas');
    c.width = w; c.height = h;
    var x = c.getContext('2d', { willReadFrequently: true });
    x.drawImage(img, 0, 0, w, h);
    var d = x.getImageData(0, 0, w, h).data;
    for (var y = h - 1; y >= 0; y--) {
      for (var i = 0; i < w; i++) {
        var p = (y * w + i) * 4;
        if (d[p + 3] > 20 && d[p] + d[p + 1] + d[p + 2] > 150) return 1 - (y + 1) / h;
      }
    }
    return 0;
  }

  function apply(item) {
    var img = item.querySelector('.product-item__thumbnail > figure:first-of-type img');
    var thumb = item.querySelector('.product-item__thumbnail');
    var cap = item.querySelector('.product-item__caption');
    if (!img || !thumb || !cap) return;
    if (!mq.matches) { cap.style.marginTop = ''; return; }
    if (!img.complete || !img.naturalWidth) {
      img.addEventListener('load', function () { apply(item); }, { once: true });
      return;
    }
    var key = img.currentSrc || img.src;
    try {
      if (!(key in cache)) cache[key] = bottomFraction(img);
      var pull = Math.max(0, cache[key] * thumb.clientHeight - 8);
      cap.style.marginTop = pull ? '-' + pull.toFixed(1) + 'px' : '';
    } catch (e) { /* obrázek nejde přečíst – nechat výchozí mezeru */ }
  }

  function run(root) {
    (root || document).querySelectorAll('.product-item').forEach(apply);
  }

  function init() {
    run();
    new MutationObserver(function (list) {
      list.forEach(function (m) {
        m.addedNodes.forEach(function (n) {
          if (n.nodeType === 1) run(n.matches && n.matches('.product-item') ? n.parentNode : n);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
    window.addEventListener('resize', function () { run(); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
